export default __webpack_public_path__ + "static/media/splash-testimonial-left.0eeafd73.svg";